import React from "react";
import { ThemeProvider } from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { sologenicTheme } from "./utils/themes.js";
import { version } from "../package.json";

function App(props) {
  const { children } = props;

  console.log("Version: " + version);

  return (
    <ThemeProvider theme={sologenicTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        {children}
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
